import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';

export const useUpdateEmail = (): any => {
  const { isLoading, status, error, send } = useRequest({
    url: '/api/v1/auth/me/changeEmail',
    method: ApiMethodsEnum.Post,
    sendOnStart: false,
    body: {},
  });

  const updateEmail = (body: { email: string }) => {
    send(body).then();
  };

  return {
    isLoading,
    error: error
      ? {
          message:
            error?.response?.data?.errors?.email ||
            error?.response?.data?.errors?.message ||
            error?.response?.data?.message,
        }
      : null,
    updateEmail,
    status,
  };
};
